<template>
  <v-dialog
    class="succes-dialog"
    v-model="dialogUpdatePassword"
    persistent
    max-width="500">
    <v-card>
      <v-toolbar dark color="success">
        <v-toolbar-title>
          <v-icon>mdi-verified mdi-24px</v-icon>
          Senha atualizada
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <h3>Agora você já pode acessar o <strong>DocGo</strong></h3>
        Clique abaixo e digite seus novos dados de segurança.
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          flat
          large
          color="accent"
          @click.native="closeDialogUpdate">
          <v-icon left>mdi-account-circle</v-icon>
          Voltar para o Login
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogSuccessPassword',
  computed: {
    dialogUpdatePassword() {
      return this.$store.getters.dialogUpdatePassword;
    },
  },
  methods: {
    closeDialogUpdate() {
      this.$store.dispatch('toggleUpdatePassword', false);
      this.$router.push('/');
    },
  },
};
</script>

<style scoped lang="scss">
.success-dialog {
  .card-content {
    padding: 2rem 4rem 0;
    max-width: 420px;
  }

  .card-action {
    padding: 1rem 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/password/update/DialogSuccessPassword.vue